export default function AlfaLeiloesQuemSomos() {

  const listaItens = document.querySelectorAll('.col-1-list li');
  const conteudos = document.querySelectorAll('.col-2-wrapper .conteudo');

  listaItens.forEach((item) => {
    item.addEventListener('click', () => {

      listaItens.forEach((item) => {
        item.classList.remove('ativo');
      });

      item.classList.add('ativo');
      const target = item.getAttribute('data-target');
      conteudos.forEach((conteudo) => {
        conteudo.classList.remove('ativo');
      });
      const conteudoSelecionado = document.getElementById(target);
      if (conteudoSelecionado) {
        conteudoSelecionado.classList.add('ativo');
      }
    });
  });

  function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }
  const tabId = getURLParameter('tab_id');
  if (tabId) {
    listaItens.forEach((item) => {
      item.classList.remove('ativo');
    });

    conteudos.forEach((conteudo) => {
      conteudo.classList.remove('ativo');
    });

    const id = Number(tabId) - 1

    const conteudoSelecionado = document.querySelectorAll('.col-1-list li')[id];
    if (conteudoSelecionado) {
      conteudoSelecionado.classList.add('ativo');
      console.log(conteudoSelecionado);
      const target = conteudoSelecionado.getAttribute('data-target');

      const content = document.getElementById(target);
      content.classList.add('ativo')
    }

  }
}
